export default __webpack_public_path__ + "static/media/openxLogo.bcabad5b.svg";